// export const API_BASE_URL =
//     process.env.REACT_APP_API_BASE_URL || 'https://ai.apphub.co.in:444';

export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || 'https://medidigestapi.apphub.co.in';
